import * as React from 'react';
import { useState } from 'react';
import { Trans, useTranslation } from "react-i18next";

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { BrowserRouter, Route, Routes, Link } from "react-router-dom"
import { ThemeProvider, createTheme } from "@mui/material/styles";

import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';

import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { blue } from '@mui/material/colors';

function MenuButton() {

  const { t, i18n } = useTranslation();

  const [open, setOpen] = useState(false);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {

    setOpen(!open)

    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  /*            <ListItemIcon>
                {0 % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              */

  const list = (anchor) => (
    <Box
      sx={{ width: 250, backgroundColor: blue }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem key={1} disablePadding>
          <Link to="/">
            <ListItemButton>
              <ListItemText primary={t("Item1")} />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem key={2} disablePadding>
          <Link to="/phyto">
            <ListItemButton>
              <ListItemText primary={t("Item2")} />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem key={3} disablePadding>
          <Link to="/report">
            <ListItemButton>
              <ListItemText primary={t("Item3")} />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem key={4} disablePadding>
          <Link to="/news">
            <ListItemButton>
              <ListItemText primary={t("Item4")} />
            </ListItemButton>
          </Link>
        </ListItem>

      </List>
    </Box>
  );

  return (

    <>


      {['right'].map((anchor) => (

        <React.Fragment
          key={anchor}
        >

          <Button
            variant="contained"
            disableElevation
            onClick={toggleDrawer(anchor, true)}
          >
            <MenuOutlinedIcon
            >
            </MenuOutlinedIcon>
          </Button>

          <Drawer
            anchor="right"
            open={state[anchor]}
            onClose={toggleDrawer(false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}

    </>
  );
}

export default MenuButton;
